import React from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {BASE_URL, CONTACT_US} from "../../../../../apis";
import qs from "querystring";
import {actionChangeInputsPageContactUs} from "../../../../../redux/actions/pages/contactUs";
import swal from 'sweetalert';

const ContentUs = () => {
    const {token} = useSelector(state => state.user);
    const {fullname,mobile,comment,subject} = useSelector(state => state.contactUs);
    const dispatch = useDispatch();

    const handelSubmitForm = (event) => {
        event.preventDefault();
        handleApiSendMessage();
    };

    const handleInputs = (event) => {
        const {name,value} = event.target;
        dispatch(actionChangeInputsPageContactUs(name,value));
    };
    const handleApiSendMessage = () => {
        axios({
            url: BASE_URL + CONTACT_US,
            method: 'post',
            data: qs.stringify(!token ? {
                name: fullname, mobile, comment, subject
            } : {comment, subject}),
            headers: token ? {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                } :
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
        }).then((response) => {
            if (response.data.status === 'ok') {
                swal({
                    text:'پیام شما با موفقیت ارسال شد.',
                    buttons: {
                        cancel: "تایید",
                    },
                    icon: "success",
                });
            }else if (response.data.status === 'error'){
                swal({
                    text:response.data.message,
                    buttons: {
                        cancel: "تایید",
                    },
                    icon: "error",
                });
            }
        });
    };
    return (
        <div className={'base-box-pages-second'}>
            <Row>
                <Col xs={12} lg={6} className={'mt-1'}>
                    <Card>
                        <Card.Header>
                            <Card.Title className={'m-0'}>راه های ارتباط با ما</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <div>
                                <span>آدرس : شيراز- میرزای شیرازی کوچه ۷، کوچه ۲۶،ساختمان ارس</span>
                            </div>
                            <div>
                                <span>تلفن : </span>
                                <a href="tel:09178788917">۸۹۱۷ ۸۷۸ ۰۹۱۷</a>
                            </div>
                            <div>
                                <span>ایمیل : </span>
                                <a href="mailto:info@fruitmruit.com">info@fruitmruit.com</a>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} lg={6} className={'mt-1'}>
                    <Card>
                        <Card.Header>
                            <Card.Title className={'m-0'}>فرم تماس با ما</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handelSubmitForm}>
                                {!token ?
                                    <React.Fragment>
                                        <Form.Group as={Row} controlId="formPlaintextEmail">
                                            <Form.Label column sm="2">
                                                موبایل
                                            </Form.Label>
                                            <Col sm="10">
                                                <Form.Control type="tel"
                                                              onChange={handleInputs}
                                                              name={'mobile'}
                                                              value={mobile}
                                                              placeholder="لطفا شماره موبایل خود را وارد کنید"/>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} controlId="formPlaintextEmail">
                                            <Form.Label column sm="2">
                                                نام
                                            </Form.Label>
                                            <Col sm="10">
                                                <Form.Control type="tel"
                                                              onChange={handleInputs}
                                                              name={'fullname'}
                                                              value={fullname}
                                                              placeholder="نام و نام خانوادگی خود را وارد کنید"/>
                                            </Col>
                                        </Form.Group>
                                    </React.Fragment>
                                    : ''}

                                <Form.Group as={Row} controlId="formPlaintextPassword">
                                    <Form.Label column sm="2">
                                        موضوع
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            onChange={handleInputs}
                                            name={'subject'}
                                            value={subject}
                                            type="text" placeholder="لطفا موضوع پیام خود را تایپ کنید"/>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} controlId="formBoxSendMessageContactUs">
                                    <Form.Label column sm="2">
                                        پیام شما
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control as="textarea"
                                                      onChange={handleInputs}
                                                      name={'comment'}
                                                      value={comment}
                                                      placeholder="میتوانید پیام خود را در این کادر بنویسید" rows="4"/>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </Card.Body>
                        <Card.Footer>
                            <Button variant="success" className={'base-btn-green btn-sm'} block
                                    onClick={handelSubmitForm}>ارسال</Button>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default ContentUs;
